import { Component, type ReactNode } from 'react'
import * as Sentry from '@sentry/react'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import i18n from '@/i18n'

interface Props {
    children: ReactNode
    fallbackMessage?: string
}

interface State {
    hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false }

    static getDerivedStateFromError(): State {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        Sentry.captureException(error, {
            contexts: { react: { componentStack: info.componentStack } },
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
                    <AlertTriangle className="h-10 w-10 mb-3 opacity-40" />
                    <p className="text-sm mb-3">{this.props.fallbackMessage || i18n.t('common.unexpectedError')}</p>
                    <Button variant="outline" size="sm" onClick={() => this.setState({ hasError: false })}>
                        {i18n.t('common.retry')}
                    </Button>
                </div>
            )
        }
        return this.props.children
    }
}
